import { useMap } from '@vis.gl/react-google-maps';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { projectToPixels } from '../utils/projectToPixels';
import { clusterByPixelDistance } from '../utils/clusterByPixelDistance';
import { clustersToRenderEntities } from '../utils/clustersToRenderEntities';
import { MAP_FIT_BOUNDS_PADDING } from '../constants/config';
export function useMapCanvas({ mapNodeId, allMarkers }) {
    const map = useMap(mapNodeId);
    const [canvas, setCanvas] = useState({
        zoom: undefined,
        bounds: undefined,
    });
    useEffect(() => {
        if (!map)
            return;
        const listener = map.addListener('idle', () => {
            const bounds = map.getBounds();
            const zoom = map.getZoom();
            if (!bounds || zoom === undefined)
                return;
            setCanvas({
                bounds,
                zoom,
            });
        });
        return () => {
            listener.remove();
        };
    }, [map]);
    const markers = useMemo(() => {
        if (!map || !canvas.bounds || !canvas.zoom)
            return [];
        const projection = map.getProjection();
        if (!projection)
            return [];
        const pixelMarkers = projectToPixels(allMarkers, canvas.bounds, projection, canvas.zoom);
        const clusters = clusterByPixelDistance(pixelMarkers);
        return clustersToRenderEntities(clusters);
    }, [map, canvas.bounds, canvas.zoom, allMarkers]);
    const fitToCluster = useCallback((cluster) => {
        if (!map)
            return;
        const bounds = new google.maps.LatLngBounds();
        cluster.members.forEach((parkMarker) => bounds.extend(new google.maps.LatLng(parkMarker.position.latitude, parkMarker.position.longitude)));
        map.fitBounds(bounds, MAP_FIT_BOUNDS_PADDING);
    }, [map]);
    return {
        canvas,
        markers,
        fitToCluster,
    };
}
